import { Injectable } from '@angular/core';
import { ForgotPasswordReqDto } from '@app/pages/auth/forgot-password/interfaces/forgot-password.req.dto';
import { ResetPasswordReqDto } from '@app/pages/auth/reset-password/interfaces/reset-password.req.dto';
import { SignInReqDto } from '@app/pages/auth/sign-in/interfaces/sign-in.req.dto';
import { SignUpReqDto } from '@app/pages/auth/sign-up/interfaces/sign-up.req.dto';
// import { ChangePasswordReqDto } from '@app/pages/edit-profile/change-pass/change-password.req.dto';
import { ChangePasswordReqDto } from '@app/pages/auth/change-password/interfaces/change-password.req.dto';
import { deepCopy } from '@app/utils/deep-copy';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable, map } from 'rxjs';
import { ApiService } from '../services/api.service';
import { AccessTokenPayload } from './interfaces/access-token-payload';
import { LogoutData } from './interfaces/logout-data';
import { NewAuthTokenResponse } from './interfaces/new-access-token-response';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private apiService: ApiService) {}

  signIn(data: SignInReqDto): Observable<NewAuthTokenResponse> {
    return this.apiService.post<NewAuthTokenResponse>('token', data);
  }

  signInWithGoogle(token: string): Observable<NewAuthTokenResponse> {
    return this.apiService.post<NewAuthTokenResponse>('auth/google', { token });
  }

  // loginFromUser(
  //   payload: LoginFromUserPayload,
  // ): Observable<ResponseSuccess<NewAuthTokenResponse>> {
  //   return this.apiService.post<ResponseSuccess<NewAuthTokenResponse>>(
  //     'login-from-user',
  //     payload,
  //   );
  // }

  logout(data: LogoutData): Observable<NewAuthTokenResponse | null> {
    return this.apiService.create<NewAuthTokenResponse | null>('logout', data);
  }

  renewAccessToken(refresh: string): Observable<NewAuthTokenResponse> {
    return this.apiService.post<NewAuthTokenResponse>('token/refresh', {
      refresh,
    });
  }

  signUp(data: SignUpReqDto): Observable<boolean> {
    return this.apiService.post('register', data).pipe(map(() => true));
  }

  confirmSignUp(token: string): Observable<boolean> {
    return this.apiService
      .post('auth/register/confirm', token)
      .pipe(map(() => true));
  }

  // confirmEmail(data: ConfirmEmailFormData): Observable<boolean> {
  //   return this.apiService.post('signup/confirm', data).pipe(map(() => true));
  // }

  decodeToken(token: string): AccessTokenPayload {
    const jwtHelper = new JwtHelperService();
    return jwtHelper.decodeToken<AccessTokenPayload>(
      token,
    ) as AccessTokenPayload;
  }

  forgotPassword(data: ForgotPasswordReqDto): Observable<any> {
    return this.apiService.post('auth/password-reset', deepCopy(data));
  }

  resetPassword(data: ResetPasswordReqDto): Observable<any> {
    return this.apiService.post('auth/password-reset/confirm/', deepCopy(data));
  }

  changePassword(data: ChangePasswordReqDto): Observable<boolean> {
    return this.apiService.post('profile/password-change', deepCopy(data));
  }
}
